import React, { useCallback, useRef, useEffect, useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import colors from 'styles/colors'
import BrandForm from 'components/form-components/BrandForm'
import FormInfo from 'components/SellWithFlip/FormInfo'
import { containerDefaultStyles } from 'styles/defaults'
import { ButtonGradientFilled } from 'components/Button'
import CaretIcon from 'images/caret.svg'

const Section = styled.section`
  padding: 40px 0;
  background: ${colors.white};
`

const Container = styled.div`
  ${containerDefaultStyles};
  width: 1440px;
  position: relative;
  color: ${colors.black};

  ${mediaQuery.bigTabletMin} {
    margin-top: 87px;
    display: flex;
    justify-content: space-between;
    gap: 17px;
  }
`

const TitleCol = styled.div`
  flex: 0 0 674px;
  text-align: center;
  ${mediaQuery.bigTabletMin} {
    text-align: left;
    display: flex;
    justify-content: space-between;
  }
`

const FormCol = styled.div`
  flex: 0 1 584px;
`

const FormWrapper = styled.div`
  position: relative;
`

const ScrollContainer = styled.div`
  background-color: ${colors.white};
  border: 1px solid #e8ecf3;
  border-radius: 16px;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.1);
  padding: 20px;
  overflow: hidden;
  position: relative;

  ${mediaQuery.bigTabletMin} {
    padding: 25px 25px 0;
    height: 750px;
    overflow-y: auto;
    scroll-behavior: smooth;
  }
`

const FormTitle = styled.h4`
  margin-bottom: 32px;

  font-size: 32px;
  font-weight: 500;
  line-height: 40px;

  ${mediaQuery.bigTabletMin} {
    padding: 0 15px;
  }
`

const ScrollButton = styled(ButtonGradientFilled)`
  display: none;

  ${mediaQuery.bigTabletMin} {
    position: absolute;
    bottom: 40px;
    right: 40px;
    z-index: 1;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: ${({ isVisible }) => (isVisible ? 'auto' : 'hidden')};
  }

  & svg {
    width: 20px;
    height: 20px;
    fill: var(--black-carbon);
  }
`

const BodyColor = createGlobalStyle`
  body {
    background-color: ${colors.white} !important;
  }
`

const ScrolledWrapper = ({ children }) => {
  const [isVisible, setVisible] = useState(true)
  const ref = useRef(null)
  const onClick = useCallback(() => {
    if (ref?.current) {
      ref?.current.scroll({
        top: 500,
        left: 0,
        behavior: 'smooth',
      })
    }
  }, [])

  const handleScroll = useCallback(() => {
    const currentScroll = ref?.current.scrollTop

    setVisible(currentScroll < 200)
  }, [])

  useEffect(() => {
    ref.current?.addEventListener('scroll', handleScroll)
    return () => ref?.current?.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <FormWrapper>
      <ScrollButton onClick={onClick} isVisible={isVisible}>
        <CaretIcon />
      </ScrollButton>
      <ScrollContainer ref={ref}>{children}</ScrollContainer>
    </FormWrapper>
  )
}

const ContactFormSection = () => (
  <>
    <BodyColor />
    <Section id="form-section">
      <Container>
        <TitleCol>
          <FormInfo />
        </TitleCol>
        <FormCol>
          <ScrolledWrapper>
            <>
              <FormTitle>Details</FormTitle>
              <BrandForm />
            </>
          </ScrolledWrapper>
        </FormCol>
      </Container>
    </Section>
  </>
)

export default ContactFormSection
